export default {
    RAZORPAY_PUBLIC_ID: "rzp_test_rrpFDSyVYUuEE4",
    HOST:"https://futurefinance.onrender.com/api",
    FORMSPREE_KEY:"xpzggoll"
}